export enum DisplayType {
    MOBILE,
    STICKY_MOBILE,
    DESKTOP,
    ACCORDION
}
